var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Featured icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M49.0308 54.7492H19.9692C19.4335 54.7492 19 54.3158 19 53.78V26.6569C19 26.4173 19.0885 26.1868 19.2488 26.0082L27.9673 16.3205C28.1504 16.116 28.4129 16 28.6877 16H49.0308C49.5665 16 50 16.4335 50 16.9692V53.78C50 54.3158 49.565 54.7492 49.0308 54.7492ZM20.9385 52.8123H48.0631V17.9385H30.6246V26.6569C30.6246 27.1927 30.1911 27.6261 29.6554 27.6261H20.9369V52.8123H20.9385ZM22.1443 25.6877H28.6877V18.4177L22.1443 25.6877Z",
    fill: "#49454F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.4069 41.1885H27.7192C27.1835 41.1885 26.75 40.755 26.75 40.2192C26.75 39.6835 27.1835 39.25 27.7192 39.25H37.4069C37.9411 39.25 38.3761 39.6835 38.3761 40.2192C38.3761 40.755 37.9411 41.1885 37.4069 41.1885Z",
    fill: "#49454F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.3438 35.376H27.7192C27.1835 35.376 26.75 34.9425 26.75 34.4067C26.75 33.871 27.1835 33.4375 27.7192 33.4375H39.3438C39.8796 33.4375 40.3131 33.871 40.3131 34.4067C40.3131 34.9425 39.8796 35.376 39.3438 35.376Z",
    fill: "#49454F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.2817 47.0005H27.7202C27.186 47.0005 26.751 46.567 26.751 46.0312C26.751 45.4955 27.1845 45.062 27.7202 45.062H41.2817C41.816 45.062 42.251 45.4955 42.251 46.0312C42.251 46.567 41.816 47.0005 41.2817 47.0005Z",
    fill: "#49454F"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImg);
export default __webpack_public_path__ + "static/media/fileImg.4077d4f5be1b8feafccb4951d2340344.svg";
export { ForwardRef as ReactComponent };